"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var keys_exports = {};
__export(keys_exports, {
  buildPublishableKey: function buildPublishableKey() {
    return _buildPublishableKey;
  },
  createDevOrStagingUrlCache: function createDevOrStagingUrlCache() {
    return _createDevOrStagingUrlCache;
  },
  isLegacyFrontendApiKey: function isLegacyFrontendApiKey() {
    return _isLegacyFrontendApiKey;
  },
  isPublishableKey: function isPublishableKey() {
    return _isPublishableKey;
  },
  parsePublishableKey: function parsePublishableKey() {
    return _parsePublishableKey;
  }
});
module.exports = __toCommonJS(keys_exports);
var import_isomorphicAtob = require("./isomorphicAtob");
var PUBLISHABLE_KEY_LIVE_PREFIX = "pk_live_";
var PUBLISHABLE_KEY_TEST_PREFIX = "pk_test_";
var PUBLISHABLE_FRONTEND_API_DEV_REGEX = /^(([a-z]+)-){2}([0-9]{1,2})\.clerk\.accounts([a-z.]*)(dev|com)$/i;
function _buildPublishableKey(frontendApi) {
  var keyPrefix = PUBLISHABLE_FRONTEND_API_DEV_REGEX.test(frontendApi) ? PUBLISHABLE_KEY_TEST_PREFIX : PUBLISHABLE_KEY_LIVE_PREFIX;
  return "".concat(keyPrefix).concat(btoa("".concat(frontendApi, "$")));
}
function _parsePublishableKey(key) {
  key = key || "";
  if (!_isPublishableKey(key)) {
    return null;
  }
  var instanceType = key.startsWith(PUBLISHABLE_KEY_LIVE_PREFIX) ? "production" : "development";
  var frontendApi = (0, import_isomorphicAtob.isomorphicAtob)(key.split("_")[2]);
  if (!frontendApi.endsWith("$")) {
    return null;
  }
  frontendApi = frontendApi.slice(0, -1);
  return {
    instanceType: instanceType,
    frontendApi: frontendApi
  };
}
function _isPublishableKey(key) {
  key = key || "";
  var hasValidPrefix = key.startsWith(PUBLISHABLE_KEY_LIVE_PREFIX) || key.startsWith(PUBLISHABLE_KEY_TEST_PREFIX);
  var hasValidFrontendApiPostfix = (0, import_isomorphicAtob.isomorphicAtob)(key.split("_")[2] || "").endsWith("$");
  return hasValidPrefix && hasValidFrontendApiPostfix;
}
function _isLegacyFrontendApiKey(key) {
  key = key || "";
  return key.startsWith("clerk.");
}
function _createDevOrStagingUrlCache() {
  var DEV_OR_STAGING_SUFFIXES = [".lcl.dev", ".stg.dev", ".lclstage.dev", ".stgstage.dev", ".dev.lclclerk.com", ".stg.lclclerk.com", ".accounts.lclclerk.com", "accountsstage.dev", "accounts.dev"];
  var devOrStagingUrlCache = /* @__PURE__ */new Map();
  return {
    isDevOrStagingUrl: function isDevOrStagingUrl(url) {
      if (!url) {
        return false;
      }
      var hostname = typeof url === "string" ? url : url.hostname;
      var res = devOrStagingUrlCache.get(hostname);
      if (res === void 0) {
        res = DEV_OR_STAGING_SUFFIXES.some(function (s) {
          return hostname.endsWith(s);
        });
        devOrStagingUrlCache.set(hostname, res);
      }
      return res;
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  buildPublishableKey: _buildPublishableKey,
  createDevOrStagingUrlCache: _createDevOrStagingUrlCache,
  isLegacyFrontendApiKey: _isLegacyFrontendApiKey,
  isPublishableKey: _isPublishableKey,
  parsePublishableKey: _parsePublishableKey
});